import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setOrg, clearOrg } from '@Redux/organization/orgActions';
import { useReduxProject } from '@Hooks/reduxProjectHook/useReduxProject';
import UrlEncryptionService from '@Helpers/UrlEncryptionService';

export const useReduxOrg = () => {

    const dispatch = useDispatch();
    const urlEncryptionService = new UrlEncryptionService();
    const { clearCurrentProject } = useReduxProject();

    const org = useSelector((state) => state.org.currentOrg);
    const orgId = org?.id ?? 0;
    const encryptedOrgId = org?.encryptedOrgId ?? '';
    const permission = useSelector((state) => state.activeUser.permission);
    const currentUserOrgPermissions = !!permission.orgs ? permission?.orgs[orgId] : {}

    const setOrgValue = useCallback(
        async (orgData) => {
            let updatedOrg = {
                ...orgData,
                encryptedOrgId: await encryptOrgId(orgData.id)
            }
            clearCurrentProject();
            dispatch(setOrg(updatedOrg))
        },
        [dispatch]
    );

    const setOrgValueWithId = useCallback(
        async (orgData, encryptedOrgId) => {
            let updatedOrg = {
                ...orgData,
                encryptedOrgId: encryptedOrgId
            }
            clearCurrentProject();
            dispatch(setOrg(updatedOrg))
        },
        [dispatch]
    );

    const clearOrgValue = useCallback(
        () => {
            clearCurrentProject();
            dispatch(clearOrg())
        },
        [dispatch]
    );

    const encryptOrgId = async (orgId)=> {
        return await urlEncryptionService.encryptData(orgId);
    }

    const getUserPermissionByOrgId = (orgId)=> {
        return !!permission.orgs ? permission?.orgs[orgId] : {}
    }

    return {
        currentOrg: org,
        currentOrgId: orgId,
        encryptedOrgId: encryptedOrgId,
        setCurrentOrg: setOrgValue,
        setCurrentOrgWithId: setOrgValueWithId,
        clearCurrentOrg: clearOrgValue,
        currentUserOrgPermissions: currentUserOrgPermissions,
        getUserPermissionByOrgId: getUserPermissionByOrgId
    };
};


